import { create } from 'zustand';
import { getRoles } from '../../../api/api';

export const useRolesStore = create((set) => ({
  roles: [],
  rolesDict: {},
  error: null,

  fetchRoles: async () => {
    set({ error: null });
    await getRoles({
      dataCb: (data) => {
        const rolesDict = Object.fromEntries((data ?? []).map((item) => [item.key, item.name]));
        set({ roles: data ?? [], rolesDict });
      },
      errCb: (err) => {
        set({ error: err });
      },
    });
  },
}));
